import type { FC } from 'react';

import { checkIsAnyWalkLeg } from '@mopla/utils';

import { TransportLeg } from './TransportLeg';
import { ILegDetailsProps } from './types';
import { WalkLeg } from './WalkLeg';
import { withLegDerivedData } from './withLegDerivedData';

const LegDetailsComponent: FC<ILegDetailsProps> = (props) => {
	const { isFirstLeg, isLastLeg, leg } = props;

	if (checkIsAnyWalkLeg(leg)) {
		return <WalkLeg isStart={isFirstLeg} isEnd={isLastLeg} />;
	}

	return <TransportLeg {...props} />;
};

export const LegDetailsV2 = withLegDerivedData(LegDetailsComponent);
